
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elanlar/[[...slug]]",
      function () {
        return require("private-next-pages/elanlar/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elanlar/[[...slug]]"])
      });
    }
  